(() => {
  const pageContent = document.querySelector(".l-page__content");
  const toc = document.querySelector(".toc__list");

  if (pageContent && toc) {
    const allH2s: NodeListOf<HTMLHeadingElement> =
      pageContent.querySelectorAll("h2");

    allH2s.forEach((h2) => {
      const { id: h2Link, innerHTML: h2Content } = h2;

      if (allH2s.length > 4) {
        toc.classList.add("is-two-columns");
      }

      toc.insertAdjacentHTML(
        "beforeend",
        `<li class="toc__item">
          <svg viewBox="0 0 20 20" class="toc__icon" xmlns="http://www.w3.org/2000/svg"><g transform="rotate(-90 10 8)" fill="none" fill-rule="evenodd"><circle cx="8" cy="8" r="8"></circle><path d="M8.75 3.8v5.589l2.45-2.45L12.26 8 8 12.26 3.74 8 4.8 6.94l2.45 2.449V3.8h1.5z" fill="currentColor" fill-rule="nonzero"></path></g></svg>
          <span class="toc__text">
          <a class="toc__link" href="${`#${h2Link}`}">${h2Content}</a>
          </span>
          </li>`
      );
    });
  }
})();

export {};
